import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authentication/authConfig";
import { LinkButton } from "../LinkButton";

export const SignInButton = () => {
  const { instance } = useMsal();
  
  return (
    <LinkButton onClick={() => instance.loginRedirect(loginRequest)}>
      Log In
    </LinkButton>
  );
};